import apiClient from "../services/api";

const KEY = "v2r_pending_daily_entries";

export const readQueue = () => {
  try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; }
};

const writeQueue = (items) => localStorage.setItem(KEY, JSON.stringify(items));

export const isNetworkError = (error) => !error?.response;

export const enqueueEntry = (payload, jobName, userId) => {
  const item = { id: crypto.randomUUID(), payload, job_name: jobName, user_id: userId, queued_at: new Date().toISOString() };
  writeQueue([...readQueue(), item]);
  return item;
};

export const showLocalNotification = async (title, body) => {
  try {
    if (!("Notification" in window) || Notification.permission !== "granted") return;
    const reg = await navigator.serviceWorker?.ready;
    if (reg) await reg.showNotification(title, { body, icon: "/logo.png", tag: `daily-entry-${Date.now()}` });
  } catch { /* notifications are best-effort */ }
};

// Try to send every queued entry. Items are claimed (removed from storage) before sending so concurrent
// flushes can never double-submit; network failures are put back. Returns { sent, failed }.
let inFlight = null;
export const flushQueue = (userId) => {
  if (inFlight) return inFlight;
  inFlight = (async () => {
    const queue = readQueue();
    const mine = queue.filter((q) => q.user_id === userId);
    if (mine.length === 0) return { sent: [], failed: [] };
    writeQueue(queue.filter((q) => q.user_id !== userId));
    const sent = [], failed = [], retry = [];
    for (const item of mine) {
      try {
        await apiClient.post(`/daily-entries`, item.payload);
        sent.push(item);
      } catch (error) {
        if (isNetworkError(error)) retry.push(item);
        else failed.push({ item, detail: error.response?.data?.detail || "Rejected by server" });
      }
    }
    if (retry.length) writeQueue([...readQueue(), ...retry]);
    return { sent, failed };
  })().finally(() => { inFlight = null; });
  return inFlight;
};
